import { rem } from 'polished'
import styled from 'styled-components'

import BedbankDetailsSection from './BedbankDetailsSection'

import { BaseImage } from 'components/Common/OrderView/styles'
import PaneDetailsSection from 'components/Common/Pane/PaneDetailsSection'
import SmallToggleButton from 'LuxKit/Button/SmallToggleButton'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import useToggle from 'hooks/useToggle'
import { useIntl } from 'react-intl'

interface Prop {
  offer: App.BedbankOffer
  order: App.Order
}

const StyledPaneDetailsSection = styled(PaneDetailsSection)`
  flex-basis: 100%;
`

const ReservedFor = styled.div`
  display: flex;
  flex-direction: column;
`

const BookingDetails = styled.div`
  padding: ${rem(20)} 0;
  display: flex;
  flex-direction: column;
  gap: ${rem(20)};
  border-bottom: 1px solid ${(props) => props.theme.palette.neutral.default.six};
`

const PackageDetails = styled(BookingDetails)``

function BedbankOfferPackageSummary({ offer, order }: Prop) {
  const intl = useIntl()
  const { value: isShowingMoreDetails, toggle: toggleShowMoreDetails } =
    useToggle()

  const yourPackageHeading = intl.formatMessage({
    id: 'ATQ2hUaqRXa1I_JNESNo',
    defaultMessage: 'Your Package',
    description: 'Heading for the accommodation package summary section',
  })

  const hideDetailsLabel = intl.formatMessage({
    id: 'WROTB4yfWNTtJqEHuisy',
    defaultMessage: 'Hide package and room details',
    description: 'Button text to collapse the package and room details section',
  })

  const viewDetailsLabel = intl.formatMessage({
    id: 'hshw9v-0r9nl57Ju-BiU',
    defaultMessage: 'View package and room details',
    description: 'Button text to expand the package and room details section',
  })

  const pkg = (
    orderBedbankRoom: App.OrderBedbankItem,
  ): App.BedbankPackage | undefined | false =>
    offer &&
    orderBedbankRoom &&
    offer?.packages &&
    offer.packages.length > 0 &&
    offer.packages.find((p) => p.roomId === orderBedbankRoom.roomTypeId)

  return (
    <>
      {order.bedbankItems.map((orderBedbankItem) => {
        return orderBedbankItem.rooms.map((orderBedbankRoom) => {
          const orderBedbankPackage = pkg(orderBedbankItem)

          const imageId =
            (orderBedbankPackage &&
              orderBedbankPackage.images &&
              orderBedbankPackage.images.length > 0 &&
              orderBedbankPackage.images[0].id) ??
              undefined

          return (
            orderBedbankRoom &&
            orderBedbankPackage && (
              <PackageDetails key={orderBedbankRoom.roomId}>
                <Heading variant="heading5">{yourPackageHeading}</Heading>
                {imageId && (
                  <BaseImage
                    className="hidden-print"
                    id={imageId}
                    mobileAspectRatio="9:4"
                    mobileWidth="100"
                  />
                )}
                {orderBedbankPackage.name && (
                  <div>
                    <BodyText variant="medium" weight="bold">
                      {orderBedbankPackage.name}
                    </BodyText>
                  </div>
                )}
                {orderBedbankRoom && (
                  <ReservedFor>
                    <BodyText variant="large">
                      {intl.formatMessage(
                        {
                          id: 'eb_GgL6w56R40ivq7AHu',
                          defaultMessage: '<bold>Reserved for</bold> {guestFirstName} {guestLastName}',
                          description: 'Guest name for accommodation reservation summary in the trip planner item editor modal',
                        },
                        {
                          guestFirstName: orderBedbankRoom.guestFirstName,
                          guestLastName: orderBedbankRoom.guestLastName,
                          bold: (chunks) => <BodyText as="span" variant="medium" weight="bold">{chunks}</BodyText>,
                        },
                      )}
                    </BodyText>
                  </ReservedFor>
                )}
                {orderBedbankPackage && (
                  <>
                    <SmallToggleButton
                      on={isShowingMoreDetails}
                      onClick={toggleShowMoreDetails}
                    >
                      {isShowingMoreDetails ? hideDetailsLabel : viewDetailsLabel}
                    </SmallToggleButton>
                    <StyledPaneDetailsSection
                      isOpen={isShowingMoreDetails}
                      onToggle={toggleShowMoreDetails}
                    >
                      <BedbankDetailsSection pkg={orderBedbankPackage} />
                    </StyledPaneDetailsSection>
                  </>
                )}
              </PackageDetails>
            )
          )
        })
      })}
    </>
  )
}

export default BedbankOfferPackageSummary
